import { h } from "@/lib/dom";
import { openModal, button, toast } from "@/components/ui";
import { presetPicker, createPresetSubjects } from "./presets";
import type { Subject } from "@/types/models";

/**
 * „Fächer aus Vorlage": dieselbe Auswahl wie im Onboarding, jederzeit erneut
 * nutzbar. Bereits angelegte Fächer sind ausgegraut, bleiben angehakt und
 * lassen sich nicht abwählen – so entstehen keine Duplikate.
 */
export function openSubjectTemplates(opts: {
  subjects: Subject[];
  onChanged: () => void;
}): void {
  const picker = presetPicker({
    existing: opts.subjects.map((s) => s.title),
    onChange: (count) => {
      addBtn.disabled = count === 0;
      addBtn.textContent = count
        ? `${count} ${count === 1 ? "Fach" : "Fächer"} hinzufügen`
        : "Fächer hinzufügen";
    },
  });

  const addBtn = button({
    label: "Fächer hinzufügen",
    variant: "primary",
    disabled: true,
    onClick: () => void add(),
  });

  async function add() {
    addBtn.disabled = true;
    // Neue Fächer hinten anhängen, damit die bestehende Reihenfolge bleibt.
    const startPosition = opts.subjects.reduce((max, s) => Math.max(max, (s.position ?? 0) + 1), 0);
    const created = await createPresetSubjects(picker, startPosition);
    handle.close();
    if (created) {
      toast(`${created} ${created === 1 ? "Fach" : "Fächer"} hinzugefügt.`, "success");
      opts.onChanged();
    }
  }

  const handle = openModal({
    title: "Fächer aus Vorlage",
    wide: true,
    guardUnsaved: false,
    body: h(
      "div",
      null,
      h(
        "p",
        { class: "muted", style: "margin-bottom:10px" },
        "Fertig eingerichtete Schulfächer (Icon, Farbe, Überschrift). Bereits vorhandene Fächer sind ausgegraut."
      ),
      picker.el
    ),
    footer: h(
      "div",
      { class: "row" },
      button({ label: "Abbrechen", variant: "ghost", onClick: () => handle.close() }),
      addBtn
    ),
  });
}
